import Request from "./Request";
export class EventRequest extends Request {
}
